import { useState, useCallback } from 'react';
import { getClientNames } from '@/lib/api/dealsApi';

export function useClientNames() {
  const [clientNames, setClientNames] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchClientNames = useCallback(async () => {
    if (clientNames.length > 0) {
      // Already loaded, return immediately
      return clientNames;
    }

    try {
      setLoading(true);
      setError(null);
      const names = await getClientNames();
      setClientNames(names);
      return names;
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Failed to load client names. Please try again later.';
      setError(errorMessage);
      console.error('Error fetching client names:', err);
      return [];
    } finally {
      setLoading(false);
    }
  }, [clientNames]);

  return {
    clientNames,
    loading,
    error,
    fetchClientNames,
  };
} 